import React, { useState, useEffect } from 'react';
import FolderFileManager from './Folders/ViewFolders';
import { formatDate } from '../../api/services';
import Navbar from './ProNavbar';
import { useLocation } from 'react-router-dom';
import { getSingleProject } from '../../api/api';
import { useTheme } from '../../ThemeContext';
import Documents from './Documents'
import AllFiles from './AllFiles'
import Teams from './Teams'
const ProjectDetails = () => {
  const [activeTab, setActiveTab] = useState('details');
  const location = useLocation();
  const [project, setProject] = useState({});
  const { data } = location.state || {};
  const { theme } = useTheme();
  const [projectName, setProjectName] = useState('');

  const isDark = theme === 'dark';

  const [id, setId] = useState('');
  // console.log(id)
  useEffect(() => {
    const response = getSingleProject(data._id)

      .then((response) => {
        setId(response.data._id);
        setProjectName(response.data.project_name);
        setProject(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [data._id]);

  return (
    <div className={`${isDark ? 'bg-gray-900 text-white' : 'bg-gray-200 text-black'} min-h-screen pt-4 pr-4 pl-4`}>


      <h2 className="text-2xl md:text-3xl font-bold text-center  pb-4 mb-2">
        Project Details for {projectName}
      </h2>
      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />



      {activeTab === 'details' && (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-6">

          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-gray-500">Description:</h3>
            <p className="text-gray-50">{project.description}</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold  text-gray-500">Cost:</h3>
            <p className="text-gray-50">{project.cost}</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold  text-gray-500">Project Manager:</h3>
            <p className="text-gray-50">{project.project_manager?.name || 'N/A'}</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold  text-gray-500">Client Side Manager:</h3>
            <p className="text-gray-50">{project.client_side_manager?.name || 'N/A'}</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold  text-gray-500">Project Status:</h3>
            <p className="text-gray-50">{project.status}</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold  text-gray-500">Project Duration:</h3>
            <p className="text-gray-50">{project.project_duration}</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold  text-gray-500">Start Date:</h3>
            <p className="text-gray-50">{formatDate(project.start_date)}</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold  text-gray-500">Estimated End Date:</h3>
            <p className="text-gray-50">{formatDate(project.end_date)}</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold  text-gray-500">End Date:</h3>
            <p className="text-s-50">{formatDate(project.actual_end_date)}</p>
          </div>
        </div>
      )}

      {activeTab === 'folders' && <FolderFileManager projectName={projectName} project_id={id} />}
      {activeTab === 'files' && <AllFiles project_id={id} />}
      {activeTab === 'documents' && <Documents project_id={id}/>}
      {activeTab ==='teams' &&<Teams project_id={id}/>}
    </div>
  );
};

export default ProjectDetails;
